import * as React from "react";
type Props = {
  className?: string,
};
function SvgWalletIllustrated({ className }: Props) {
  return (
    <svg
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-WalletIllustrated"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.824.395 26.52 0l-.396.303-6.386 4.883H3.988v7.978H0v30.917h42.878a2 2 0 0 0 2-2V7.186a2 2 0 0 0-2-2H30.509L26.825.396ZM4.99 6.186h13.44l-9.125 6.978H4.989V6.186Zm5.964 6.978h-.001L26.335 1.4l9.05 11.764H10.953Zm25.7 0h-.007L31.28 6.186h11.599a1 1 0 0 1 1 1v4.978a1 1 0 0 1-1.001 1h-6.224Zm6.224 1c.364 0 .706-.098 1-.268V42.08a1 1 0 0 1-1 1H1V36.1h14.458a7.48 7.48 0 0 0 0-14.96H1v-6.977h41.877ZM1 22.141V35.1h14.458a6.48 6.48 0 0 0 0-12.96H1Zm12.464 7.974a1.493 1.493 0 1 0 0-2.986 1.493 1.493 0 0 0 0 2.986Zm2.493-1.493a2.493 2.493 0 1 1-4.986 0 2.493 2.493 0 0 1 4.986 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgWalletIllustrated;
